import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UWRequirementActionEvent, UWRequirementTableData } from '@Underwriting/models';
import { UWRequirementTableActions, UWRequirementTableProps } from '../uw-requirements-expand-table';
import { NgIf } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';
import { SharedModule } from '@Shared/shared.module';
import { UWRequirementsActionsItemDocumentComponent } from '../uw-requirements-actions-item-documents';
import { UWRequirementsActionsItemAgentCommunicationsComponent } from '../uw-requirements-actions-item-agent-communications/uw-requirements-actions-item-agent-communications.component';


@Component({
    selector: 'uw-requirements-actions-cancelled',
    templateUrl: './uw-requirements-actions-cancelled.component.html',
    styleUrls: ['./uw-requirements-actions-cancelled.component.scss'],
    imports: [
        SharedModule,
        forwardRef(() => UWRequirementsActionsItemDocumentComponent),
        forwardRef(() => UWRequirementsActionsItemAgentCommunicationsComponent)
    ]
})
export default class UWRequirementsActionsCancelledComponent {
    @Input() caseRequirement: UWRequirementTableData;
    @Input() props: UWRequirementTableProps;
    @Output() onMenuAction = new EventEmitter<UWRequirementActionEvent>();
    public get UWRequirementTableActions() {
        return UWRequirementTableActions;
    }
    handleMenuAction(columnAction: UWRequirementTableActions, caseRequirement: UWRequirementTableData) {
        const actionEvent: UWRequirementActionEvent = {
            action: columnAction,
            data: caseRequirement
        };

        this.handleMenuActionEvent(actionEvent);
    }

    handleMenuActionEvent(event: UWRequirementActionEvent) {
        this.onMenuAction.emit(event);
    }
}